import axios from 'axios'
import interceptors from './interceptors'
import { apiPostValidateOtp } from '@/modules/User/services/authentication'
import router from '@/router'

let API_BASE_URL
// for testing purposes
API_BASE_URL =
  process.env.API_BILLMA || 'https://billma.tadaima.studio/api-systema'
export class BillmaHttpClient {
  constructor() {
    this.client = axios.create({ baseURL: API_BASE_URL })

    interceptors.createRequestInterceptorBillma(this)
    interceptors.createResponseInterceptor(this, async () => {
      const sinisterID = sessionStorage.getItem('sinId')
      const otpCode = sessionStorage.getItem('otpCode')
      await apiPostValidateOtp(sinisterID, otpCode)
    }, router)
  }

  request(method, url, data, config) {
    return new Promise((resolve, reject) => {
      this.client[method](url, data, config || {})
        .then((response) => {
          resolve(response.data)
        })
        .catch(async (error) => {
          if (error.response.status === 401) { // refresh token
            if (sessionStorage.getItem('renewToken') === 'false') {
              sessionStorage.setItem('mavAuth', null)
              sessionStorage.setItem('renewToken', 'true')
              const sinisterID = sessionStorage.getItem('sinId')
              const otpCode = sessionStorage.getItem('otpCode')
              const token = await apiPostValidateOtp(sinisterID, otpCode, true)
              if (token) {
                sessionStorage.setItem('mavAuth', `Token ${token.token}`)
                this.client[method](url, data, config || {})
                  .then((response) => {
                    resolve(response.data)
                    sessionStorage.setItem('renewToken', 'false')
                  })
              }
            } else {
              setTimeout(() => {
                this.client[method](url, data, config || {})
                  .then((response) => {
                    resolve(response.data)
                  })
              }, 3000)
            }
          } else if (error.status === 403) { // expired token
            if (router) {
              router.replace({ name: 'timedout' })
            }
          } else {
            reject(error)
          }
        })
    })
  }

  initInterceptors() {
    interceptors.createRequestInterceptor(this)
    interceptors.createResponseInterceptor(this)
  }

  get(url, data, config) {
    return this.request('get', url, data, config)
  }

  post(url, config) {
    return this.request('post', url, config)
  }

  put(url, config) {
    return this.request('put', url, config)
  }

  patch(url, config) {
    return this.request('patch', url, config)
  }

  delete(url, config) {
    return this.request('delete', url, config)
  }

  getFile(url) {
    const token = sessionStorage.getItem('mavAuth')
    const bearerToken = token ? token.replace('Token', 'Bearer') : token
    return fetch(`${API_BASE_URL}/${url}`, {
      method: 'GET',
      headers: {
        Authorization: bearerToken
      }
    }).then((response) => {
      return response.blob()
    })
  }
}

const billmaHttpClient = new BillmaHttpClient()

export default billmaHttpClient
